import React from 'react'

export function Emma({
  children,
  className = '',
  color = '',
  tooltip = '',
}) {
  return (
    <div className={`relative overflow-visible ${className}`}>
      {tooltip &&
        <div className="p-2 font-semibold text-white uppercase rounded-md down-arrow">
          <div className="absolute top-0 left-0 w-full h-full shadow-xl"></div>
          {tooltip}
        </div>
      }
      <img className="ml-auto mr-0" src={color == '' ? `/images/emma.png` : `/images/emma_${color}.png`} alt="Emma" width="72" />
    </div>
  )
}
